var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emptyTxt2"},[_c('img',{attrs:{"src":require("@/assets/zanwu.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.test || '暂无审批流程'))])])}
var staticRenderFns = []

export { render, staticRenderFns }